import React, { useEffect, useRef, useState } from "react";
import styles from "./completedOrder.module.scss";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import { Button, FormControl, InputLabel, OutlinedInput } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { connect, useDispatch } from "react-redux";
import {
  getAllOrders,
  getDeliveredOrders,
  getPendingOrdersResponse,
  getProductById,
} from "../../store/actions";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import { getObjectFromArrayOfObjects } from "../../utils/common/CommonFunctions";
const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },
  {
    id: 2,
    label: "Order ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 3,
    label: "Cart Bundle ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 4,
    label: "Customer Name",
    minWidth: 170,
    align: "center",
  },
  {
    id: 5,
    label: "Status",
    minWidth: 170,
    align: "center",
  },
];

const CompletedOrder = ({ orders = [], customers = [] }) => {
  const [displayOrders, setDisplayOrders] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // dispatch(getDeliveredOrders());
    dispatch(getAllOrders());
  }, []);

  const handleFilter = () => {
    const filterData = orders?.filter((item) => item?.status === 3);
    return filterData;
  };

  const handleNavigate = (item = {}) => {
    dispatch(getPendingOrdersResponse(item));
    dispatch(getProductById({ id: item?.productId }));
    navigate("/orderdetails");
  };

  const mergeOrdersWithCustomers = () => {
    return handleFilter()?.map((order) => {
      const customer = customers.find((c) => c.id === order.customerId);
      console.log(customer, "customer")
      return {
        ...order,
        // customerName: customer?.name || "NA",
        customerName: customer?.fullName || "NA",
      };
    });
  };

  

  useEffect(() => {
    setDisplayOrders(mergeOrdersWithCustomers());
  }, [orders, customers]);

  // Search handler
  const handleSearch = (value) => {
    if (!value.trim()) {
      setDisplayOrders(mergeOrdersWithCustomers());
    } else {
      const filtered = mergeOrdersWithCustomers().filter((order) =>
        order.customerName.toLowerCase().includes(value.toLowerCase())
      );
      setDisplayOrders(filtered);
    }
  };
  const getStructuredRows = (data = []) => {
    return data.map((item, idx) => ({
      id: item.id,
      rColumns: [
        idx + 1,
        <Button
          variant="outlined"
          className={styles.ovalButtonOut}
          disableRipple
          disableElevation
          onClick={() => handleNavigate(item)}
        >
          {item.orderCode || "NA"}
        </Button>,
        item.cartBundleId,
        item.customerName,
        <Button
          variant="contained"
          className={styles.ovalButton3}
          disableRipple
          disableElevation
        >
          Delivered
        </Button>,
      ],
    }));
  };
  console.log("display orders", displayOrders)

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            {/* <SearchInput
              placeholder="Search by customer name"
              onSearch={(value) => handleSearch(value)}
            /> */}

          </div>
        </div>
        <div className={styles.bottom}>
          <GenCustomTable columns={columns} rows={getStructuredRows(displayOrders)} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    orders: state?.orders?.orders,
    customers: state?.customer?.customers
  };
};

export default connect(mapStateToProps, null)(CompletedOrder);
